var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditlabelicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3700 4880 c-19 -10 -585 -569 -1256 -1242 l-1222 -1223 -182 -548 c-169 -509 -182 -553 -178 -607 6 -80 42 -133 111 -166 29 -13 70 -24 91 -24 25 0 245 68 585 181 l546 181 1229 1227 c850 849 1234 1238 1247 1266 24 52 24 119 -2 175 -27 60 -725 761 -781 784 -52 22 -144 20 -188 -4z m295 -680 l190 -190 -1105 -1104 -1105 -1104 -275 -91 c-151 -50 -280 -91 -287 -91 -7 0 26 113 83 283 l94 282 1103 1103 c606 606 1104 1102 1107 1102 3 0 91 -86 195 -190z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 628 c-20 -5 -54 -25 -76 -44 -101 -86 -93 -251 17 -329 l43 -30 1866 -3 c1027 -1 1882 0 1900 3 49 9 127 88 142 145 24 91 -16 189 -98 237 l-47 28 -1855 2 c-1185 0 -1868 -2 -1892 -9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditlabelicon);
export default __webpack_public_path__ + "static/media/edit label icon.f25f6baceb85632335367725275a0f2d.svg";
export { ForwardRef as ReactComponent };